import { LitElement, html, css } from '@hh/global.js'

class HHVideoControl extends LitElement {

  connectedCallback() {
    super.connectedCallback()
    this.initVideoControls()
  }

  initVideoControls() {
    const videoEl = this.querySelectorAll('adaptive-video')
    const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    this.controls?.forEach((control, controlIndex) => {
      control.addEventListener('click', () => {
        const video = videoEl[controlIndex]?.shadowRoot?.querySelector('video')
        if (video) {
          if (isVideoPlaying(video)) {
            video.pause()
            control.classList.add('--is-paused')
          } else {
            video.play()
            control.classList.remove('--is-paused')
          }
        }
      })
    })
  }

  get controls() {
    return this.querySelectorAll('.js-hero-controls') ?? null
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-media-control', HHVideoControl)
